import { render, staticRenderFns } from "./limitsSelects.vue?vue&type=template&id=8667eb8c&scoped=true"
import script from "./limitsSelects.vue?vue&type=script&lang=js"
export * from "./limitsSelects.vue?vue&type=script&lang=js"
import style0 from "./limitsSelects.vue?vue&type=style&index=0&id=8667eb8c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8667eb8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8667eb8c')) {
      api.createRecord('8667eb8c', component.options)
    } else {
      api.reload('8667eb8c', component.options)
    }
    module.hot.accept("./limitsSelects.vue?vue&type=template&id=8667eb8c&scoped=true", function () {
      api.rerender('8667eb8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/basic/limitsSelects/limitsSelects.vue"
export default component.exports